var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnStsKt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#CACACA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8977_76344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.81531 12.8662L11.0383 11.4769H9.60695C9.07747 11.4769 8.55761 11.5888 8.17987 11.895L8.07302 12.0177V7.5H6.61817C6.45407 7.50039 6.29684 7.56081 6.18096 7.66802C6.06508 7.77522 6 7.92045 6 8.07187V16.502H7.45379C7.61797 16.5016 7.77528 16.4411 7.89118 16.3338C8.00708 16.2265 8.07209 16.0811 8.07195 15.9296V13.6855L9.24737 15.0166L10.2486 16.1539C10.3348 16.2603 10.4465 16.3467 10.575 16.4066C10.7035 16.4665 10.8452 16.4981 10.9891 16.499H13.0194L11.7077 15.0141L9.81531 12.8662ZM15.6176 14.3944V11.476H13.5425V14.7538C13.5425 15.7891 14.3156 16.5 15.4365 16.5H17.0324C17.1969 16.4999 17.3547 16.4395 17.4711 16.3322C17.5875 16.2249 17.653 16.0794 17.6532 15.9276V14.9091H16.1733C16.1002 14.909 16.0278 14.8956 15.9603 14.8696C15.8928 14.8437 15.8315 14.8058 15.7799 14.758C15.7283 14.7102 15.6874 14.6535 15.6596 14.5911C15.6318 14.5287 15.6175 14.4619 15.6176 14.3944ZM17.9989 10.4466V9.17616L17.8702 9.30138C17.867 9.30483 17.4775 9.67161 16.3592 9.67161H15.6176V7.5H14.1633C13.999 7.5 13.8414 7.56008 13.7251 7.66708C13.6087 7.77409 13.543 7.91929 13.5425 8.07088V9.67161H11.0725C10.2385 9.67161 9.84363 9.98466 9.5455 10.3233L8.33161 11.7037C8.33161 11.7037 8.90543 11.2028 9.74746 11.2028H16.3587C17.0821 11.2028 17.5779 11.0717 17.8333 10.8139C18.0182 10.6295 17.9995 10.4505 17.9989 10.4471V10.4466Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8977_76344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9,
    fill: "white",
    transform: "translate(6 7.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnStsKt);
export default __webpack_public_path__ + "static/media/unStsKt.adb09e499a9ae07d7dd974e296dc4b1a.svg";
export { ForwardRef as ReactComponent };